import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';

class Carousel extends Component {
  constructor(props) {
    super(props);

    this.index = 0;
    this.position = 0;
    this.wordState = "";

    this.state = {
      word: "",
      cursor: ""
    };
	  
  }
	
	//gotoPage() {
	//    localStorage.setItem("bugHistory", 0);
	//    this.props.history.push({pathname: "/assets "});
	//		const url = "/assets?assetline=2,2_4";
	//	return url
	//}

  render() {
    //const handleScrollToElement = this.props.handleScrollToElement;
	  
	  const { t } = this.props;

    return (
      <header className="carousel">
        <div className="carousel-overlay">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="carousel-container">
                  <h1 className="carousel-title text-center">
	                  {t('carousel.title1')} {/*Conquistando*/}
                  </h1>
                  <h1 className="carousel-title text-center">
	                  {t('carousel.title2')} {/*Experiências Únicas*/}

                  </h1>
                  <h2 className="carousel-subtitle text-center mb-5">
                    <br />
                  </h2>

                  {/*<Link to="/assets?assetline=2,2_4">*/}
                    <img
                      className="d-block m-auto" width="150" alt="sun"
                      src="/assets/images/logo-drums-plate.png"/>
                    <br />
                  {/*</Link>*/}

                  <br />
                  <div className="row justify-content-center">

                      {/*<div className="col-lg-4">
                      <a
                        onClick={e => handleScrollToElement(e, "main")}
                        className="btn btn-block btn-cta cta-item text-center">
                        How it Works
                      </a>
                    </div> */}

                    <div className="col-lg-4">
                      <Link
                        className="btn btn-cta cta-item text-center"
                        to="/assets/?assetline=2,Gospel">
	                      {t('carousel.expbutton')} {/*Experiências*/}
                      </Link>
                    </div>{" "}
                    {/* Go to Company */}

                  </div>{" "}
                  {/*  Buttons */}

                  <br/>

                    {/*<div className="col-lg-12 col-md-7 col-sm-12">
                    <input className="input-search" type="text" placeholder="Search Bands"
                           onInput={this.handleInput}
                           onChange={this.handleChange}
                           value={this.state.valueSearch} />
                  </div>*/}

                    {/* <img className="arrow-down" src="assets/images/down.gif" alt=""
                    onClick={e => handleScrollToElement(e, "assets")} */}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withTranslation()(Carousel);



// WEBPACK FOOTER //
// ./src/containers/HomePage/carousel.js